import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Api
import dashboard_api from '../../../api/dashboard_api';
import { showMessage } from 'helpers/message';
export default function ContratosPorModalidade({ btnVoltar, id, modalidade, prefeituraId }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Headers da tabela de contratos por modalidades
    const headers = [
        { value: "Gerador", objectValue: "gerador" },
        { value: "Endereço", objectValue: "endereco" },
        { value: "Ramo de atividade", objectValue: "ramoDeAtividade" },
        { value: "Periodicidade", objectValue: "periodicidade" },
        { value: "Transportador", objectValue: "transportador" },
    ];

    //Estado que guarda os dados da tabela
    const [contratos, setContratos] = useState([]);

    //Carregando os dados da tabela
    useEffect(() => {
        setLoading(true);
        dashboard_api.ContratosPorModalidade(id, prefeituraId).then(response => {
            setContratos(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    return (
        <MainCard
            title={modalidade}
            noCard
            btnVoltarInTop={btnVoltar}
        >
            {loading && <Loading />}
            <TabelaListagem
                title='Lista de contratos por modalidade'
                headers={headers}
                items={contratos}
                options={{ print: false, search: true, pagination: true }}
            />
        </MainCard>
    );

}